import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';


@Injectable({
  providedIn: 'root'
})
export class FileHelperService {

  public static MimeTypes = {
    Excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  };

  constructor() { }

  downloadbase64File(fileName: string, base64Data: string, mimeType: string = FileHelperService.MimeTypes.Excel) {
    const byteCharacters = atob(base64Data); // Decode base64 string
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    saveAs(blob, fileName);
  }

}
